import { Rocket, MessageCircle } from "lucide-react";
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from "react-router-dom";
import { readySolutions } from '../data/readySolutions';
import i18n from "../i18n";


/**
 * Две бесконечные бегущие строки «как у Heygen»
 * – карточки повторяются для бесшовной прокрутки.
 * Настраивай скорость через prop speed (в секундах).
 */

function MarqueeRow({ items, reverse = false, speed = 45 }) {
  // Дублируем контент для непрерывного цикла
  const loop = [...items, ...items];
  

  return (
    <div
      className={`marquee relative overflow-hidden`}
      style={{ ["--duration"]: `${speed}s` }}
    >
      <ul
        className={`marquee__track flex flex-nowrap gap-4 sm:gap-6 will-change-transform`}
        style={{
          animationDirection: reverse ? "reverse" : "normal",
        }}
      >
        {loop.map((it, idx) => (
          <li
            key={idx}
            className="marquee__item shrink-0 w-[520px] max-w-[90vw] rounded-2xl border border-gray-200 bg-white p-5 sm:p-6 shadow-sm"
          >
            <img src={it.image} style={{ width: '20px', height: '20px'}} />
            <h4 className="mt-2 text-[15px] sm:text-base font-semibold text-gray-900">
              {it.title}
            </h4>
            <p className="mt-2 text-sm leading-6 text-gray-600">{it.desc}</p>
            <Link to={`/doc/${it.id}`} target="_blank" rel="noopener noreferrer">Подробнее</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function BestPracticesTicker() {
  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const items = readySolutions.map(it => ({
    ...it,
    title: t(it.titleKey),
    desc:  t(it.descKey),
  }));
  const top = items.slice(0, 9);
  const bottom = items.slice(9);

  return (
    <section className="relative bg-[#F5F6FB] py-12 sm:py-16">
      {/* мягкий фон-градиент */}
        {/* Верхняя полоса: слева заголовки, справа кнопки */}
        <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between px-[20px] sm:px-[100px] lg:px-[200px] mb-5">
          <div>
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-purple-600" />
              {t('$Subheader18')}
            </div>

            <h2 className="mt-2 text-3xl sm:text-4xl font-extrabold leading-tight">
              <span className="bg-gradient-to-r from-purple-700 to-purple-400 bg-clip-text text-transparent">
                {t('$Header15')}
              </span>
            </h2>

            <p className="mt-1 text-2xl sm:text-3xl font-extrabold text-gray-900">
              {t('$Header16')}
            </p>
          </div>

          <div className="flex items-center gap-3">
            <button
              type="button"
              className="inline-flex items-center gap-2 rounded-full bg-purple-600 text-white px-5 py-2.5 text-sm font-medium shadow hover:bg-purple-700 transition"
              onClick={() => navigate(`/login`)}
            >
              <Rocket className="w-4 h-4" />
              {t('$Buttom6')}
            </button>
            <button
              type="button"
              className="inline-flex items-center gap-2 rounded-full bg-black text-white px-5 py-2.5 text-sm font-medium shadow hover:opacity-90 transition"
              onClick={() => {
                window.location.href = "mailto:info@best-practices.online";
              }}
            >
              <MessageCircle className="w-4 h-4" />
              Talk To Sales
            </button>
          </div>
        </div>

      <div className="relative mx-auto">
        {/* Первая линия */}
        <MarqueeRow items={top} speed={46} />

        {/* Вторая линия (встречное движение) */}
        <div className="mt-6 sm:mt-8">
          <MarqueeRow items={bottom} reverse speed={52} />
        </div>
      </div>

      {/* Локальные стили для анимации */}
      <style>{`
        .marquee:hover .marquee__track { animation-play-state: paused; }

        .marquee__track {
          min-width: 200%;
          animation: scroll var(--duration, 45s) linear infinite;
          animation-duration: 18s !important;
        }
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        @media (width >= 768px) and (orientation: portrait),
        (width >= 1025px) { 
          .marquee__track { animation-duration: 28s !important; }
        }

        @media (width >= 1440px) {
          .marquee__track { animation-duration: 28s !important; }
        }
      `}</style>
    </section>
  );
}
